module.exports = __webpack_public_path__ + "static/media/dataImport.469546b9.svg";